import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function DetailFooterNav({ to, label }: { to: string; label: string }) {
  return (
    <nav className="mer-detail-footer">
      <Link to={to} className="mer-detail-back">
        ← {label}
      </Link>
    </nav>
  );
}

export function DetailMetaGrid({ children }: { children: ReactNode }) {
  return <dl className="mer-detail-meta-grid">{children}</dl>;
}

export function DetailMetaItem({ label, value }: { label: string; value: ReactNode }) {
  return (
    <>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </>
  );
}

export function DetailList({
  children,
  testId,
  ariaLabel,
}: {
  children: ReactNode;
  testId?: string;
  ariaLabel?: string;
}) {
  return (
    <ul className="mer-detail-list" data-testid={testId} aria-label={ariaLabel}>
      {children}
    </ul>
  );
}

export function DetailListCard({
  title,
  badge,
  meta,
  actions,
  leading,
  testId,
}: {
  title: ReactNode;
  badge?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  /** Control pinned before the title, e.g. a bulk-select checkbox. */
  leading?: ReactNode;
  testId?: string;
}) {
  return (
    <li className="mer-detail-list-item" data-testid={testId}>
      {leading ? <div className="mer-detail-list-leading">{leading}</div> : null}
      <div className="mer-detail-list-item-head">
        <span className="mer-detail-list-title">{title}</span>
        {meta ? <div className="mer-detail-list-meta">{meta}</div> : null}
      </div>
      {badge || actions ? (
        <div className="mer-detail-list-actions">
          {badge}
          {actions}
        </div>
      ) : null}
    </li>
  );
}

export function EntityStatusBadge({
  status,
  tone,
}: {
  status: string;
  tone?:
    | 'published'
    | 'draft'
    | 'hidden'
    | 'neutral'
    | 'danger'
    | 'success'
    | 'warning'
    | 'pending'
    | 'evidence'
    | 'urgent';
}) {
  const normalized = status.toUpperCase().replace(/\s+/g, '_');
  const resolved =
    tone ??
    ([
      'PUBLISHED',
      'ACTIVE',
      'OPEN',
      'PAID',
      'COMPLETE',
      'COMPLETED',
      'READY',
      'ACCEPTED',
      'TRADING',
      'APPROVED',
    ].includes(normalized)
      ? 'published'
      : normalized === 'DRAFT'
        ? 'draft'
        : ['PENDING', 'PREPARING', 'IN_PREPARATION'].includes(normalized)
          ? 'pending'
          : normalized === 'EVIDENCE_SUBMITTED' || normalized.includes('EVIDENCE')
            ? 'evidence'
            : normalized === 'URGENT'
              ? 'urgent'
              : ['HIDDEN', 'INACTIVE', 'REJECTED', 'CANCELLED'].includes(normalized)
                ? 'neutral'
                : 'neutral');
  const label = status.replace(/_/g, ' ');
  return <span className={`mer-entity-status mer-entity-status-${resolved}`}>{label}</span>;
}
